<ng-container *ngIf="type === 'secondary'">
    <button dssOutlineButton (click)="actionClick.emit({action:action})"
    trackingClick [eventLabel]="eventLabel" [disabled]="disabled" id="{{elementId}}">{{text}}</button>
</ng-container>
<ng-container *ngIf="type === 'primary'">
    <button dssFilledButton (click)="actionClick.emit({action:action})"
    trackingClick [eventLabel]="eventLabel" [disabled]="disabled" id="{{elementId}}">{{text}}</button>
</ng-container>
